import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'ErrorMessage'
})
export default class ErrorMessage extends Vue {}
